<ng-container [formGroup]="form">
    <input matInput type="text" formControlName="timeInput" />
</ng-container>
